var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-card',{attrs:{"flat":""}},[_c('v-card-title',{staticClass:"justify-center"},[_vm._v("Customer Balance Summary")]),_c('v-card-text',{staticClass:"justify-center"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }